import { Backdrop, CircularProgress } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';

interface BackdropComponentProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

const BackdropComponent = ({ open, setOpen }: BackdropComponentProps) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Backdrop
      sx={(theme) => ({ color: '#fff', zIndex: 9999 })}
      open={open}
      onClick={(event) => event.stopPropagation()}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default BackdropComponent;
